import React from 'react'
import { styled } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { breakpoints } from 'src/ui/dimensions'

const Wrapper = styled.div`
  width: 268px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.mobile}px) {
    width: 100%;
    margin-bottom: 40px;
  }
  &:last-child {
    margin-bottom: 30px;
  }
`

const IconWrap = styled.div`
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto 32px;
`

const Title = styled(Header)`
  color: ${({ theme }) => theme.colors.black.primary};
  height: 66px;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: ${breakpoints.mobile}px) {
    height: auto;
  }
`

const Subtitle = styled(Body)`
  color: ${({ theme }) => theme.colors.black.secondary};
  text-align: center;
`

type Props = {
  icon: React.ReactNode
  title: string
  subtitle: string
}

export const BonusStep: React.FC<Props> = ({ icon, title, subtitle }) => {
  return (
    <Wrapper>
      <IconWrap>{icon}</IconWrap>
      <Title size="h5">{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Wrapper>
  )
}
